import { NetworkType } from '../../../types/types';

export interface CreateWithdrawPartnerRequest {
  amount: number;
  userWalletId: number;
  emailCode: string;
  twoFACode: string;
  networkType: NetworkType;
  networkCurrencyType: string;
}

export interface CreateWithdrawExplorerRequest {
  amount: number;
  userWalletId: number;
  emailCode: string;
  twoFACode: string;
}

export interface CreateWithdrawExplorerVerificationEmailRequest {
  amount: number;
  userWalletId: number;
  verificationCode: string;
}

export interface GetWithdrawAvailabilityResponse {
  isAvailable: boolean;
  limitDate: string;
  withdrawUnavailableReason: string;
}

export interface GetWithdrawAvailabilityResponse {
  isAvailable: boolean;
  limitDate: string;
  withdrawUnavailableReason: string;
}

export interface EarnBetResponse {
  id: number;
  price: number;
  receivedAmount: number;
  status: number;
  dateCreated: string; // or Date if you want to parse it into a Date object
  datePaid: string; // or Date
  networkType: number;
  paymentAddress: string;
  isPartnerNotified: boolean;
  currencyType: number;
  networkCurrencyType: string;
}

export enum WalletActivation {
  ACTIVE = 1,
  INACTIVE = 2
}
